import { T_CONTACT_US_PAGE_CONSTANTS } from './TYPES'

const EN_CONTACT_US_PAGE_CONSTANTS: T_CONTACT_US_PAGE_CONSTANTS = {
  PAGE_KICKER: 'ANY OTHER QUESTION?',
  PAGE_TITLE: 'Contact Us',
  THANKYOU_PAGE_TITLE: 'Your request has been successfully submitted. 🎉',
  GENERIC_ERROR_TOAST_MESSAGE: 'Something went wrong. please try again later'
}

export default EN_CONTACT_US_PAGE_CONSTANTS
